import React from 'react';
import { Field,  reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, Select, HtmlEditor } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, isHtml, languages, t,
	lang, componentClass, rows }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Select name='languageId' data={languages} horizontal required label={t('Localization_Language')} validate={validators.required} />
			{isHtml && <Field name='text' component={HtmlEditor} disabled={isReadonly} lang={lang} horizontal type='text' label={t('Localization_Text')} />}
			{!isHtml && <Field name='text' component={Input} disabled={isReadonly} horizontal type='text' componentClass={componentClass} rows={rows} label={t('Localization_Text')} />}
		</Form>
	);
};

export default reduxForm({ form: 'localization' })(withTranslation()(SettingsForm));
